import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// All providers (theme, auth, shop/cart) are set up once, inside App.js.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);